import { UserVSPaperInsert, UserVSPaperInsertMany, UserVSPaperDelete, UserVSPaperUpdate, UserVSPaperUpdateMany, UserVSPaperGetById, UserVSPaperGetList, UserVSPaperGetPageList } from "@/api/uservspaper/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    UserVSPaperInsert(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSPaperInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    UserVSPaperInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSPaperInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    UserVSPaperUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSPaperUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    UserVSPaperUpdateMany(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSPaperUpdateMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    UserVSPaperGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSPaperGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    UserVSPaperGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSPaperGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    UserVSPaperGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSPaperGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}